import { combineReducers } from 'redux';
import grusers from './grusers';

export default {
  '@@gruser': combineReducers({
    grusers,
  }),
};
